'use strict';

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _util = require('../util');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {
      background: theme.bgMeta,
      borderTopLeftRadius: 10,
      borderBottomRightRadius: theme.cardBorderRadius,
      color: theme.colorMeta,
      fontSize: theme.metaText || 12,
      marginLeft: 'auto',
      padding: [[3, 10, 3]],
      textAlign: 'right',
      '& > *:not(:first-child)': {
        marginLeft: 10
      }
    },
    wide: {
      width: '100%',
      borderRadius: 0
    },
    link: {
      color: 'inherit'
    }
  };
};

var CardMeta = (_dec = (0, _util.withStyles)(styles), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(CardMeta, _React$Component);

  function CardMeta() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CardMeta);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CardMeta.__proto__ || Object.getPrototypeOf(CardMeta)).call.apply(_ref, [this].concat(args))), _this), _this.convertLink = function (link, className) {
      if (typeof link === 'string') {
        if (link.startsWith('https://') || link.startsWith('http://')) {
          var text = link.split('://')[1];

          if (text.startsWith('www.')) {
            text = text.split('www.')[1];
          }

          return _react2["default"].createElement('a', {
            href: link,
            target: '_blank',
            className: className
          }, text);
        }
      }

      return link;
    }, _this.convertValue = function (key, value, classes) {
      if (key === 'score' && typeof value === 'number') {
        return value.toFixed(2);
      }

      if (typeof value != 'string') {
        return String(value);
      }

      return _this.convertLink(value, classes.link);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CardMeta, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          visible = _props.visible,
          wide = _props.wide,
          classes = _props.classes;
      var rootClassNames = (0, _classnames2["default"])(classes.root, 'prodigy-meta', _defineProperty({}, classes.wide, !!wide));
      return visible ? _react2["default"].createElement('div', {
        className: rootClassNames
      }, typeof content == 'string' ? this.convertLink(content) : Object.entries(content).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];

        return _react2["default"].createElement('span', {
          key: key
        }, _react2["default"].createElement('strong', null, key.toUpperCase(), ': '), _this2.convertValue(key, value, classes));
      })) : null;
    }
  }]);

  return CardMeta;
}(_react2["default"].Component), _class2.defaultProps = {
  content: {}
}, _class2.propTypes = {
  size: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].object])
}, _temp2)) || _class);
exports["default"] = CardMeta;